/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationStatus } from './HomeHealthCertificationStatus';
import {
    HomeHealthCertificationStatusFromJSON,
    HomeHealthCertificationStatusFromJSONTyped,
    HomeHealthCertificationStatusToJSON,
    HomeHealthCertificationStatusToJSONTyped,
} from './HomeHealthCertificationStatus';
import type { HomeHealthCertificationReference } from './HomeHealthCertificationReference';
import {
    HomeHealthCertificationReferenceFromJSON,
    HomeHealthCertificationReferenceFromJSONTyped,
    HomeHealthCertificationReferenceToJSON,
    HomeHealthCertificationReferenceToJSONTyped,
} from './HomeHealthCertificationReference';
import type { HomeHealthCertificationReviewReason } from './HomeHealthCertificationReviewReason';
import {
    HomeHealthCertificationReviewReasonFromJSON,
    HomeHealthCertificationReviewReasonFromJSONTyped,
    HomeHealthCertificationReviewReasonToJSON,
    HomeHealthCertificationReviewReasonToJSONTyped,
} from './HomeHealthCertificationReviewReason';

/**
 * 
 * @export
 * @interface HomeHealthCertificationEvidence
 */
export interface HomeHealthCertificationEvidence {
    /**
     * 
     * @type {HomeHealthCertificationStatus}
     * @memberof HomeHealthCertificationEvidence
     */
    status: HomeHealthCertificationStatus;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationEvidence
     */
    summary: string;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationEvidence
     */
    source_category: HomeHealthCertificationEvidenceSourceCategoryEnum;
    /**
     * 
     * @type {Array<HomeHealthCertificationReviewReason>}
     * @memberof HomeHealthCertificationEvidence
     */
    review_reasons: Array<HomeHealthCertificationReviewReason>;
    /**
     * 
     * @type {Array<HomeHealthCertificationReference>}
     * @memberof HomeHealthCertificationEvidence
     */
    supporting_ref: Array<HomeHealthCertificationReference>;
    /**
     * 
     * @type {Array<HomeHealthCertificationReference>}
     * @memberof HomeHealthCertificationEvidence
     */
    counterevidence_ref: Array<HomeHealthCertificationReference>;
}


/**
 * @export
 */
export const HomeHealthCertificationEvidenceSourceCategoryEnum = {
    HhaGenerated: 'hha_generated',
    Practitioner: 'practitioner',
    AcutePostAcute: 'acute_post_acute',
    Mixed: 'mixed',
    Unknown: 'unknown'
} as const;
export type HomeHealthCertificationEvidenceSourceCategoryEnum = typeof HomeHealthCertificationEvidenceSourceCategoryEnum[keyof typeof HomeHealthCertificationEvidenceSourceCategoryEnum];


/**
 * Check if a given object implements the HomeHealthCertificationEvidence interface.
 */
export function instanceOfHomeHealthCertificationEvidence(value: object): value is HomeHealthCertificationEvidence {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    if (!('source_category' in value) || value['source_category'] === undefined) return false;
    if (!('review_reasons' in value) || value['review_reasons'] === undefined) return false;
    if (!('supporting_ref' in value) || value['supporting_ref'] === undefined) return false;
    if (!('counterevidence_ref' in value) || value['counterevidence_ref'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationEvidenceFromJSON(json: any): HomeHealthCertificationEvidence {
    return HomeHealthCertificationEvidenceFromJSONTyped(json, false);
}

export function HomeHealthCertificationEvidenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationEvidence {
    if (json == null) {
        return json;
    }
    return {
        
        'status': HomeHealthCertificationStatusFromJSON(json['status']),
        'summary': json['summary'],
        'source_category': json['source_category'],
        'review_reasons': ((json['review_reasons'] as Array<any>).map(HomeHealthCertificationReviewReasonFromJSON)),
        'supporting_ref': ((json['supporting_ref'] as Array<any>).map(HomeHealthCertificationReferenceFromJSON)),
        'counterevidence_ref': ((json['counterevidence_ref'] as Array<any>).map(HomeHealthCertificationReferenceFromJSON)),
    };
}

export function HomeHealthCertificationEvidenceToJSON(json: any): HomeHealthCertificationEvidence {
    return HomeHealthCertificationEvidenceToJSONTyped(json, false);
}

export function HomeHealthCertificationEvidenceToJSONTyped(value?: HomeHealthCertificationEvidence | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': HomeHealthCertificationStatusToJSON(value['status']),
        'summary': value['summary'],
        'source_category': value['source_category'],
        'review_reasons': ((value['review_reasons'] as Array<any>).map(HomeHealthCertificationReviewReasonToJSON)),
        'supporting_ref': ((value['supporting_ref'] as Array<any>).map(HomeHealthCertificationReferenceToJSON)),
        'counterevidence_ref': ((value['counterevidence_ref'] as Array<any>).map(HomeHealthCertificationReferenceToJSON)),
    };
}

